import {TrailBalanceConfig} from 'main/content/accountingReports/trailBalance/TrailBalanceConfig';
import {pettyCashReportConfig} from 'main/content/accountingReports/pettyCash/pettyCashReportConfig';
import {LedgerReportConfig} from 'main/content/accountingReports/ledgerReport/LedgerReportConfig';
import {JournalEntryReportConfig} from 'main/content/accountingReports/journalEntryReport/JournalEntryReportConfig';
import {ProfitAndSaleReportConfig} from 'main/content/accountingReports/profitAndSaleReport/ProfitAndSaleReportConfig';
import {CashBookReportConfig} from 'main/content/accountingReports/cashBookReport/cashBookReportConfig';
import {BalanceSheetConfig} from 'main/content/accountingReports/balanceSheet/BalanceSheetConfig';
export const AccountingReportsConfig = [
    TrailBalanceConfig,
    LedgerReportConfig,
    JournalEntryReportConfig,
    pettyCashReportConfig,   
    ProfitAndSaleReportConfig,
    CashBookReportConfig,
    BalanceSheetConfig
]; 


// WEBPACK FOOTER //
// ./src/main/content/accountingReports/AccountingReportsConfig.js